// src/utils/gtmUtils.js
import TagManager from 'react-gtm-module';

let isInitialized = false;

export const initializeGTM = () => {
  if (!isInitialized && typeof window !== 'undefined') {
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_KEY|| '',
    });
    isInitialized = true;
    console.log("GTM Initialized");
  }
};

export const sendGTMEvent = (eventName, eventData = {}) => {
  try {
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: eventName,
        ...eventData,
      });
      console.log("GTM Event Sent:", eventName, eventData);
    }
  } catch (error) {
    console.error("Error sending GTM event:", error);
  }
};
